import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from 'recharts';
import { useKPAIS } from '@hooks/dashboard/useKapi';

const COLORS = ['#3B82F6', '#F59E0B', '#10B981'];

const RegistrationFunnel: React.FC = () => {
  const { data, isLoading } = useKPAIS();

  if (isLoading) return <div className="chart-loading">Loading...</div>;

  const totalFoodCourts = data?.totalFoodcourtCount || 0;
  // Approximate: assume 60% approved, 25% pending, 15% rejected as typical funnel
  const chartData = [
    { stage: 'Registered', count: totalFoodCourts, fill: '#3B82F6' },
    { stage: 'Pending', count: Math.round(totalFoodCourts * 0.25), fill: '#F59E0B' },
    { stage: 'Active', count: Math.round(totalFoodCourts * 0.6), fill: '#10B981' },
  ];

  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#F3F4F6" vertical={false} />
        <XAxis dataKey="stage" tick={{ fontSize: 11, fill: '#374151', fontWeight: 600 }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fontSize: 10, fill: '#9CA3AF' }} axisLine={false} tickLine={false} />
        <Tooltip
          contentStyle={{ background: '#0B1829', border: 'none', borderRadius: 10, color: '#fff', fontSize: 12 }}
          formatter={(value: number, name: string) => [value, 'Food Courts']}
        />
        <Bar dataKey="count" radius={[8, 8, 0, 0]} maxBarSize={60}>
          {chartData.map((entry, index) => (
            <Cell key={index} fill={COLORS[index % COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RegistrationFunnel;
